"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "asolo": {
    "89f0fc74": [{
      "hkey": "dfeb34e6",
      "slug": "casella-d-asolo-sant-apollinare",
      "name": "Casella d'Asolo-Sant'Apollinare",
      "primary": true,
      "skipSearch": false
    }],
    "casella-d-asolo": [{
      "hkey": "dfeb34e6",
      "slug": "casella-d-asolo-sant-apollinare",
      "name": "Casella d'Asolo-Sant'Apollinare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65cdb1b6": [{
      "hkey": "dfeb34e6",
      "slug": "casella-d-asolo-sant-apollinare",
      "name": "Casella d'Asolo-Sant'Apollinare",
      "primary": true,
      "skipSearch": false
    }],
    "sant-apollinare": [{
      "hkey": "dfeb34e6",
      "slug": "casella-d-asolo-sant-apollinare",
      "name": "Casella d'Asolo-Sant'Apollinare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asolo"
    }]
  }
};
exports["default"] = _default;